var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowWithCircleIcon = function SvgArrowWithCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 22C4.935 22 0 17.066 0 11S4.935 0 11 0s11 4.935 11 11-4.935 11-11 11m0-20.095c-5.015 0-9.095 4.08-9.095 9.095s4.08 9.095 9.095 9.095 9.095-4.08 9.095-9.095S16.015 1.905 11 1.905m1.066 3.708-1.353 1.342 3.06 3.092H5.232v1.906h8.513l-3.116 3.088 1.34 1.353 5.44-5.388z"
  })));
};
export default SvgArrowWithCircleIcon;